<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .cta-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: utils.in_rem(4px);

    .cta-label {
      overflow: hidden;
      text-overflow: ellipsis;
      color: colors.get(textBlack);
      @include mixins.body4();
    }
  }
</style>

<script>
  // Svelte
  import { getContext } from "svelte";
  // Stores
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  // Components
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import Toggletip from "@sourcewhale/shared/svelte-design-system/components/atoms/Toggles/Toggletip.svelte";
  import Dropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/Dropdown.svelte";
  import MoreInfo from "./MoreInfo.svelte";
  import SendMessagePhoneList from "./SendMessagePhoneList.svelte";
  // Utils
  import { hasConversationsLicense } from "@sourcewhale/core";
  // Context
  import { CONTACT_CTAS_CONTEXT } from "./context";

  // Get store from context
  const { candidatePhoneStore, activePopUpModalStore } =
    getContext(CONTACT_CTAS_CONTEXT);

  let {
    kind = "secondary",
    size = "candidate-cta",
    leadingIcon = "",
    wrapper = true,
    style = "",
    tooltipPlacement = "top",
    dropdownPlacement = "bottom",
    children,
  } = $props();

  const whatsappButtonProps = $state({
    kind,
    size,
    leadingIcon,
    style,
    trailingIcon: "",
  });

  let closeDropdown = $state(null);
  const openModal = (number) => {
    if (closeDropdown) closeDropdown();

    activePopUpModalStore.set({
      modal: "sendMessage",
      kind: "whatsapp",
      number,
    });
  };

  const moreInfoProps = () => {
    if (!$userStore.extensionSmsEnabled) {
      return {
        info: $userStore.isAdmin
          ? "Your team does not have WhatsApp enabled. Please contact us to learn more."
          : "Your team does not have WhatsApp enabled. Please contact your admin to enable it.",

        buttonText: "Learn More",
        href: "https://help.sourcewhale.app/en/articles/10741195-beta-whatsapp-integration",
      };
    }
    return {
      info: "To use WhatsApp, link your WhatsApp with SourceWhale in your Profile Settings.",
      buttonText: "Profile Settings",
      href: "/profile",
    };
  };
</script>

{#snippet button()}
  {#if $candidatePhoneStore.length === 0 || !hasConversationsLicense($userStore)}
    <ButtonWithTooltip
      {...whatsappButtonProps}
      class="disabled"
      placement={tooltipPlacement}
    >
      <span slot="tooltip"
        >{hasConversationsLicense($userStore)
          ? "No phone numbers available."
          : "Using WhatsApp requires a Conversations license."}</span
      >
      {@render children?.()}
    </ButtonWithTooltip>
  {:else if !$userStore.extensionSmsEnabled || $userStore.whatsappAccountStatus !== "active"}
    <Toggletip placement={tooltipPlacement} let:toggle>
      <MoreInfo slot="toggletip" {...moreInfoProps()} />
      <Button {...whatsappButtonProps} onclick={toggle}>
        {@render children?.()}
      </Button>
    </Toggletip>
  {:else if $candidatePhoneStore.length === 1}
    {@const phoneObj = $candidatePhoneStore[0]}
    <ButtonWithTooltip
      {...whatsappButtonProps}
      placement={tooltipPlacement}
      onclick={() => openModal(phoneObj.phone)}
    >
      <span slot="tooltip">Send a WhatsApp message to {phoneObj.phone}</span>
      {@render children?.()}
    </ButtonWithTooltip>
  {:else}
    <Dropdown
      {...whatsappButtonProps}
      placement={dropdownPlacement}
      {tooltipPlacement}
      dynamicWidth={false}
      bind:close={closeDropdown}
    >
      <span slot="button">{@render children?.()}</span>
      <span slot="tooltip">Send a WhatsApp message</span>
      <SendMessagePhoneList kind="whatsapp" onPhoneClick={openModal} />
    </Dropdown>
  {/if}
{/snippet}

{#if wrapper}
  <div class="cta-wrapper">
    {@render button()}
    <span class="cta-label">WhatsApp</span>
  </div>
{:else}
  {@render button()}
{/if}
